module.exports = __webpack_public_path__ + "img/6.8f173ff8.png";